import { z } from 'zod/v4';

export const assetInviteResultSchema = z.object({
  ErrorCode: z.string().nullable(),
  TotalInvitesSent: z.number(),
  TotalInvitesFailed: z.number(),
});

// Can't z.infer because of name changes
export type AssetInviteResult = {
  errorCode: null | string;
  totalInvitesFailed: number;
  totalInvitesSent: number;
};
